"use client";

import {
  Form,
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from "@/app/_components/ui/form";
import { SignupFormValues } from "@/app/_lib/schemas/auth";
import { UseFormReturn } from "react-hook-form";
import { sendVerificationToken } from "../lib/actions";
import { useState } from "react";
import { Loader2 } from "lucide-react";

export default function Email({
  form,
  onNextStep,
}: {
  form: UseFormReturn<SignupFormValues>;
  onNextStep: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: SignupFormValues) => {
    try {
      setLoading(true);
      const response = await sendVerificationToken(data.email);
      if (response && response.success) {
        onNextStep();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-3.5 w-full"
      >
        <FormField
          name="email"
          control={form.control}
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <input
                  type="email"
                  placeholder="Your email address"
                  {...field}
                  className={`w-full px-4 py-3 text-sm border rounded-xl bg-background outline-none transition-colors ${
                    form.formState.errors.email
                      ? "border-red-400"
                      : "border-border focus:border-primary"
                  }`}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-primary text-white text-sm font-semibold rounded-xl hover:opacity-90 transition-opacity disabled:opacity-60 flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <Loader2 size={16} className="animate-spin" />
              Sending…
            </>
          ) : (
            "Send verification code"
          )}
        </button>
      </form>
    </Form>
  );
}
